import Button from "kustom-front/src/components/atoms/Button";
import React, { FunctionComponent } from "react";
import "./style.scss";

interface Props {
  code: string;
  description: string;
  onSelectPromo: () => void;
  title: string;
}

const PromoItem: FunctionComponent<Props> = ({ code, description, onSelectPromo, title }) => {
  return (
    <div className="PromoItem">
      <div className="PromoItem-texts">
        <h3 className="PromoItem-title">{title}</h3>
        <div className="PromoItem-description">{description}</div>
      </div>
      <Button type="primary-darker" onClick={onSelectPromo}>
        {code}
      </Button>
    </div>
  );
};

export default PromoItem;
